import { motion } from 'motion/react'
import { mq, pxToRem, sizes } from 'src/theme'
import styled from 'styled-components'

import ActionButton from '../ActionButton'
import BlockTitle from '../BlockTitle'
import Picture from '../Picture'
import RichText from '../RichText'
import Slider from '../Slider'

export const Container = styled.section<{ $color?: string }>`
  --background-color: ${({ $color }) => $color ?? 'transparent'};
  --padding-block: ${({ $color }) =>
    $color ? `${pxToRem(32)} ${pxToRem(40)}` : 0};
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(56)};
  background-color: var(--background-color);
  padding-block: var(--padding-block);
  &:not(:first-child) {
    margin-block-start: var(--g_spacing__blocks);
  }
  @media ${mq(sizes.desktop)} {
    --padding-block: ${({ $color }) => ($color ? `${pxToRem(80)}` : 0)};
    gap: ${pxToRem(144)};
  }
`
export const Text = styled.p`
  ${({ theme }) => theme.textStyles.d1440_body}
  @media ${mq(sizes.tablet)} {
  }
`
export const _BlockTitle = styled(BlockTitle)`
  width: 100%;
  max-width: calc(100% - ${pxToRem(16)} * 2);
  margin-inline: auto;
  @media ${mq(sizes.desktop)} {
    max-width: calc(100% - ${pxToRem(32)} * 2);
  }
`
export const Pushes = styled(Slider)`
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(40)};
  padding-inline: ${pxToRem(16)};
  overflow: hidden;
  & .keen-slider[data-keen-slider-disabled],
  & .keen-slider:not([data-keen-slider-disabled]) {
    padding-block: 1px;
    overflow: visible;
  }

  @media ${mq(sizes.desktop)} {
    width: 100%;
    max-width: calc(100% - ${pxToRem(32)} * 2);
    margin-inline: auto;
    padding-inline: 0;
    & .keen-slider[data-keen-slider-disabled],
    & .keen-slider:not([data-keen-slider-disabled]) {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: ${pxToRem(16)};
    }
  }
`
export const Push = styled.article`
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(24)};
  @media ${mq(sizes.desktop)} {
    gap: ${pxToRem(32)};
  }
`

export const PushCaption = styled(motion.section)`
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(24)};
  @media ${mq(sizes.desktop)} {
    gap: ${pxToRem(32)};
  }
`

export const Title = styled(motion.h3)`
  ${({ theme }) => theme.textStyles.m375_h2}
  max-width: calc(100% - ${pxToRem(30)});
  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.d1440_h2}
    max-width: min(${pxToRem(580)}, 83%);
  }
`
export const _RichText = styled(RichText)`
  ${({ theme }) => theme.textStyles.m375_body}
  max-width: calc(100% - ${pxToRem(30)});
  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.d1440_body}
    max-width: min(${pxToRem(580)}, 83%);
  }
`
export const _ActionButton = styled(ActionButton)`
  margin-block-start: auto;
`
export const _Picture = styled(motion.create(Picture))`
  & img {
    aspect-ratio: 8/7;
    object-fit: cover;
  }

  & + * {
    margin-block-start: ${pxToRem(8)};
  }
  @media ${mq(sizes.desktop)} {
    & + * {
      margin-block-start: ${pxToRem(24)};
    }
    & img {
      aspect-ratio: 9/8;
    }
  }
`
